import { render, staticRenderFns } from "./tui3.vue?vue&type=template&id=2e1ecc97&scoped=true&"
import script from "./tui3.vue?vue&type=script&lang=js&"
export * from "./tui3.vue?vue&type=script&lang=js&"
import style0 from "./tui3.vue?vue&type=style&index=0&id=2e1ecc97&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1ecc97",
  null
  
)

export default component.exports